import {ChangeDetectionStrategy, Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject, Signal} from '@angular/core';
import {RouterOutlet} from "@angular/router";
import {HorizontalMenuComponent} from "./horizontal-menu/horizontal-menu.component";
import {VersionService} from "@vision-inspection/environment";



@Component({
  selector: 'app-default-layout',
  imports: [
    RouterOutlet,
    HorizontalMenuComponent
  ],
  templateUrl: './default-layout.component.html',
  styleUrl: './default-layout.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DefaultLayoutComponent {
  private readonly versionService: VersionService = inject(VersionService);

  protected projectVersion: Signal<string> = computed(() => this.versionService.getProjectVersion());
}
